module.exports = __webpack_public_path__ + "img/heart-pink.24bdf3da.svg";